import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TPaginationInfo } from '@monorepo/types';
import * as _ from 'lodash';
import { TUserPaginationOption } from './pagination.types';
import { TranslateService } from '@ngx-translate/core';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { PopoverController } from '@ionic/angular';
import { TdropdownItems } from '../dropdown/dropdown.types';

@Component({
  selector: 'monorepo-listing-pagination',
  templateUrl: './listing-pagination.component.html',
  styleUrls: ['./listing-pagination.component.scss'],
})
export class ListingPaginationComponent {
  @Input() itemsPerPageList: Readonly<number[]> = [10, 20, 30, 40, 50];
  // NOTE ! symbol before the @Input variable means values will always come
  @Input() paginationInfo!: TPaginationInfo;
  // @Input() paginationOption: TUserPaginationOption | null = null;
  @Input() set paginationOption(v: TUserPaginationOption) {
    if (v && !_.isEqual(v, this.userPaginationOption)) {
      this.userPaginationOption = v;
    }
  }
  @Input() listItemsDisplayVal = '';
  @Input() renderType: 'TABLE' | 'TNA' = 'TABLE';
  @Input() hideItemsPerPage = false;
  @Output() updateUserPaginationTuple = new EventEmitter<TUserPaginationOption>();

  isPageCountDropdownOpen = false;
  isItemsPerPgeCountDropdownOpen = false;

  constructor(private translate: TranslateService, private popoverController: PopoverController) {}

  userPaginationOption: TUserPaginationOption = {
    pageNo: 1,
    pageSize: 10,
  };

  #emitUserPaginationTuple() {
    this.updateUserPaginationTuple.emit(this.userPaginationOption);
  }

  #changeItemsPerPage(itemsPerPage: number) {
    if (itemsPerPage !== this.userPaginationOption.pageSize) {
      console.log('[pagination] onItemsPerPageChange', itemsPerPage);
      this.userPaginationOption = {
        pageNo: 1,
        pageSize: itemsPerPage,
      };
      this.#emitUserPaginationTuple();
    }
  }

  #changeCurrentPage(pageNo: number) {
    if (pageNo !== this.userPaginationOption.pageNo) {
      console.log('[pagination] onCurrentPageChange', pageNo);
      this.userPaginationOption = {
        ...this.userPaginationOption,
        pageNo,
      };
      this.#emitUserPaginationTuple();
    }
  }

  async openItemsPerPageList($event: Event) {
    this.isItemsPerPgeCountDropdownOpen = true;
    const items: TdropdownItems<number> = this.itemsPerPageList.map((val) => ({
      type: val,
      displayText: val.toString(),
      backgroundColor: this.userPaginationOption.pageSize === val ? '#eff2fe' : '',
    }));

    const popover = await this.popoverController.create({
      component: DropdownComponent,
      event: $event,
      animated: false,
      showBackdrop: false,
      alignment: 'center',
      cssClass: 'listing-pagination-popover',
      componentProps: {
        items: items,
      },
    });
    await popover.present();
    const dismissValue = await popover.onWillDismiss();
    if (dismissValue) {
      this.isItemsPerPgeCountDropdownOpen = false;

      if (dismissValue.data !== undefined) this.#changeItemsPerPage(dismissValue.data);
    }
  }

  async openPageCount($event: Event) {
    this.isPageCountDropdownOpen = true;
    const items: TdropdownItems<number> = Array.from({ length: this.paginationInfo.totalPageCount }, (_, index) => ({
      type: index + 1,
      displayText: (index + 1).toString(),
      backgroundColor: this.userPaginationOption.pageNo === index + 1 ? '#eff2fe' : '',
    }));

    const popover = await this.popoverController.create({
      component: DropdownComponent,
      event: $event,
      animated: false,
      showBackdrop: false,
      alignment: 'center',
      cssClass: 'listing-pagination-popover',
      componentProps: {
        items: items,
      },
    });
    await popover.present();
    const dismissValue = await popover.onWillDismiss();
    if (dismissValue) {
      this.isPageCountDropdownOpen = false;

      if (dismissValue.data !== undefined) this.#changeCurrentPage(dismissValue.data);
    }
  }
}
